import { ReplaySubject } from 'rxjs';
import { SendMessageError, SendReplyError } from './errors/message.errors.js';
import '@polkadot/util';
import './utils/generate.js';
import './utils/prefixes.js';
import './utils/separator.js';
import { validateValue, validateGasLimit, validateVoucher, validateMailboxItem } from './utils/validate.js';
import '@polkadot/api';
import '@polkadot/util-crypto';
import { encodePayload } from './utils/create-payload.js';
import { GearTransaction } from './Transaction.js';

class GearMessage extends GearTransaction {
    /**
     * ## Send Message
     * @param message
     * @param metaOrHexRegistry Metadata
     * @param typeIndexOrTypeName type index in registry or type name
     * @returns Submitted result
     */
    async send({ destination, value, gasLimit, payload, prepaid, account }, metaOrHexRegistry, typeIndexOrTypeName) {
        validateValue(value, this._api);
        validateGasLimit(gasLimit, this._api);
        if (prepaid && account) {
            await validateVoucher(destination, account, this._api);
        }
        const _payload = encodePayload(payload, metaOrHexRegistry, 'handle', typeIndexOrTypeName);
        try {
            this.extrinsic = this._api.tx.gear.sendMessage(destination, _payload, gasLimit, value || 0, prepaid || false);
            return this.extrinsic;
        }
        catch (error) {
            throw new SendMessageError(error.message);
        }
    }
    /**
     * Sends reply message
     * @param args Message parameters
     * @param metaOrHexRegistry Metadata
     * @param typeIndexOrTypeName type index in registry or type name
     * @returns Submitted result
     */
    async sendReply({ value, gasLimit, replyToId, payload, prepaid, account }, metaOrHexRegistry, typeIndexOrTypeName) {
        validateValue(value, this._api);
        validateGasLimit(gasLimit, this._api);
        let source;
        if (account) {
            const msg = await validateMailboxItem(account, replyToId, this._api);
            source = msg.source.toHex();
        }
        if (prepaid && account && source) {
            await validateVoucher(source, account, this._api);
        }
        const _payload = encodePayload(payload, metaOrHexRegistry, 'reply', typeIndexOrTypeName);
        try {
            this.extrinsic = this._api.tx.gear.sendReply(replyToId, _payload, gasLimit, value, prepaid || false);
            return this.extrinsic;
        }
        catch (error) {
            throw new SendReplyError();
        }
    }
    listenToReplies(programId, bufferSize = 5) {
        let unsub;
        const subject = new ReplaySubject(bufferSize);
        this._api.gearEvents
            .subscribeToGearEvent('UserMessageSent', ({ data }) => {
            if (data.message.source.eq(programId)) {
                if (data.message.details.isSome) {
                    data.message.details.unwrap().to.toHex();
                    {
                        subject.next([data.message.details.unwrap().to.toHex(), data]);
                    }
                }
            }
        })
            .then((result) => {
            unsub = result;
        });
        return (messageId) => {
            return new Promise((resolve) => {
                subject.subscribe({
                    next: ([id, data]) => {
                        if (id === messageId) {
                            subject.complete();
                            unsub();
                            resolve(data);
                        }
                    },
                });
            });
        };
    }
}

export { GearMessage };
